<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">Ver. 1.3.6 {{ year }} © Psicóloga</div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          Design & Develop by
          <a
            href="https://nuvoll.co"
            target="_blank"
            class="text-decoration-underline"
            >Nuvoll</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
